import { Lock } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { EmptyState } from '@/components/ui/empty-state'

interface NoDoerAssignedStateProps {
  className?: string
  onRetry?: () => void
  retrying?: boolean
}

export function NoDoerAssignedState({ className, onRetry, retrying = false }: NoDoerAssignedStateProps) {
  return (
    <EmptyState
      className={className}
      data-testid="no-doer-assigned-state"
      icon={<Lock className="h-8 w-8" />}
      title="Playbooks are unavailable right now"
      description={
        <>
          <p>A Doer must be assigned to your workspace before you can view or manage playbooks.</p>
          <p className="mt-1">Please contact your admin to assign a Doer.</p>
        </>
      }
      action={
        onRetry && (
          <Button variant="outline" onClick={onRetry} disabled={retrying}>
            {retrying ? 'Retrying...' : 'Retry'}
          </Button>
        )
      }
    />
  )
}
